import { Image } from '../components/Image';
import { Link } from '../components/Link';
import { Badge } from '../components/Badge';
import { Gauge, Fuel, MapPin, Settings2 } from 'lucide-react';

const capitalize = (word = '') => (word ? word.charAt(0).toUpperCase() + word.slice(1) : '');
const formatMileage = (mileage) => {
  if (mileage === null || mileage === undefined || mileage === '') return null;
  return `${Number(mileage).toLocaleString('en-US')} km`;
};

const formatPrice = (value, currency = 'KES') => {
  const numeric = Number(value ?? 0);
  const label = currency === 'USD' ? '$' : currency === 'KES' ? 'Ksh ' : `${currency} `;
  return `${label}${numeric.toLocaleString('en-US')}`;
};

const CarCard = ({ car }) => {
  const safeCar = car ?? {};
  const displayName = [safeCar.make, safeCar.model].filter(Boolean).join(' ') || safeCar.name || 'Vehicle';
  const displayYear = safeCar.year;
  const displayType = safeCar.bodyType;
  const displayTransmission = safeCar.transmission;
  const displayFuelType = safeCar.fuelType || safeCar.fuel_type;
  const displayMileage = formatMileage(safeCar.mileage);
  const displayPrice = safeCar.price ?? safeCar.priceKsh ?? 0;
  const displayCurrency = safeCar.currency || 'KES';
  const imageSrc = safeCar.images?.[0] || safeCar.image || 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=1200&q=80';
  const badge = safeCar.badge || safeCar.condition;

  return (
    <article className="group overflow-hidden rounded-xl border border-border bg-white transition-shadow duration-300 hover:shadow-xl">
      <Link href={`/inventory/${safeCar.id}`} className="block">
      <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
        <Image
          variant="cover"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          src={imageSrc}
          alt={displayName}
        />
        {badge && (
          <Badge className="absolute left-3 top-3 rounded-full bg-[#c1392a] px-3 py-1 text-[10px] font-bold uppercase tracking-wide text-white">
            {badge}
          </Badge>
        )}
      </div>
      <div className="p-4">
        <h3 className="truncate font-heading text-lg font-bold text-dark">{displayName}</h3>
        <div className="mt-1 flex flex-wrap gap-x-2 text-xs text-muted">
          {[displayYear, displayType].filter(Boolean).map((value, index) => (
            <span key={`${value}-${index}`}>{capitalize(String(value))}</span>
          ))}
        </div>
        <div className="mt-4 flex min-h-5 flex-wrap gap-x-3 gap-y-2 text-xs text-muted">
          {displayMileage && <span className="flex items-center gap-1"><Gauge className="h-3.5 w-3.5" />{displayMileage}</span>}
          {displayFuelType && <span className="flex items-center gap-1"><Fuel className="h-3.5 w-3.5" />{capitalize(displayFuelType)}</span>}
          {displayTransmission && <span className="flex items-center gap-1"><Settings2 className="h-3.5 w-3.5" />{capitalize(displayTransmission)}</span>}
        </div>
        {(safeCar.yardName || safeCar.sellerLocation || safeCar.location) && <div className="mt-3 text-xs text-muted"><p className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{safeCar.sellerLocation || safeCar.location}</p>{safeCar.yardName && <p className="mt-1 font-semibold text-dark">{safeCar.yardName}</p>}</div>}
        <div className="mt-4 border-t border-border pt-3">
          <div className="font-heading text-xl font-bold text-[#c1392a]">
            {formatPrice(displayPrice, displayCurrency)}
          </div>
        </div>
      </div>
      </Link>
    </article>
  );
};

export default CarCard;